import { createContext, useContext } from 'react';
// @ts-ignore
import { TLogLevels } from './LoggerContext';
import { Generic, ProductNames } from '../interfaces/interfaces';
import { Endpoint } from '../store/Actions';

export interface IConfigProps {
    appBasePath: string;
    appName: string;
    logLevel: TLogLevels | undefined;
    product: ProductNames.CAR | ProductNames.CHILD;
    endpoint: Generic<Endpoint>;
}

const ConfigContext = createContext<IConfigProps>({} as IConfigProps);

export { ConfigContext };
export const useConfigContext = () => useContext(ConfigContext);
